import { useState, useEffect } from "react";
import { Megaphone, X, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";

const DISMISS_KEY = "tw_intranet_announce_dismissed";

const getDismissed = () => {
    try { return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || "[]"); }
    catch { return []; }
};

export default function IntranetAnnouncementsBanner() {
    const [items, setItems] = useState([]);
    const [dismissed, setDismissed] = useState(getDismissed);
    const navigate = useNavigate();

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const { data } = await api.get("/intranet/announcements");
                if (alive) setItems(data.announcements || []);
            } catch { /* ignore */ }
        })();
        return () => { alive = false; };
    }, []);

    const visible = items.filter((a) => !dismissed.includes(`${a.id}:${a.updated_at}`));
    if (visible.length === 0) return null;

    const dismiss = (a) => {
        const key = `${a.id}:${a.updated_at}`;
        const next = [...dismissed, key];
        setDismissed(next);
        try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(next)); } catch { /* ignore */ }
    };

    return (
        <div className="mb-4 space-y-2" data-testid="intranet-announcements-banner">
            {visible.map((a) => (
                <div key={a.id} className="flex items-start gap-3 rounded-sm border-l-4 border-[#FFCC00] bg-[#FFFBEB] px-4 py-3" data-testid={`announcement-${a.id}`}>
                    <Megaphone className="w-5 h-5 text-[#111827] shrink-0 mt-0.5" />
                    <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="font-bold text-sm text-[#111827] break-words">{a.title}</span>
                            {a.owner_site_code && (
                                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-sm ${a.owner_is_hauptsitz ? "bg-[#111827] text-white" : "bg-gray-100 text-gray-600 border border-gray-300"}`}>
                                    {a.owner_site_code}{a.owner_is_hauptsitz ? " · HS" : ""}
                                </span>
                            )}
                        </div>
                        {a.info && <p className="text-sm text-gray-600 mt-0.5 line-clamp-2 break-words">{a.info}</p>}
                        <button onClick={() => navigate("/intranet")} className="mt-1 inline-flex items-center gap-1 text-xs font-bold text-[#111827] hover:underline" data-testid={`announcement-open-${a.id}`}>
                            Im Intranet öffnen <ArrowRight className="w-3 h-3" />
                        </button>
                    </div>
                    <button onClick={() => dismiss(a)} className="p-1 text-gray-400 hover:text-gray-700 shrink-0" title="Ausblenden" data-testid={`announcement-dismiss-${a.id}`}>
                        <X className="w-4 h-4" />
                    </button>
                </div>
            ))}
        </div>
    );
}
